import { Component, OnInit } from '@angular/core';
import { ContentfulService } from '../../../core/contentful.service';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Entry } from 'contentful';
import { switchMap } from 'rxjs/operators';
import { NavbarService } from '../../../core/navbar.service';
import { SeoService } from '../../../core/seo.service';

@Component({
  selector: 'app-exhibits-details',
  templateUrl: './exhibits-details.component.html',
  styleUrls: ['./exhibits-details.component.css']
})
export class ExhibitsDetailsComponent implements OnInit {
  exhibit: Entry<any>;
  constructor(
    private seo: SeoService,
    private ContentfulService: ContentfulService,
    public nav: NavbarService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.nav.show();
    this.route.paramMap
    .pipe(switchMap((params: ParamMap) => this.ContentfulService.getExhibit(params.get('slug'))))
    .subscribe( exhibit=> {
      this.exhibit = exhibit;
      if (exhibit && exhibit.fields) {
        const title = exhibit.fields.title || 'Exhibit';
        const description = exhibit.fields.description || 'Explore this historic exhibit at the Bayou Lacombe Museum.';
        const imageUrl = exhibit.fields.image?.fields?.file?.url 
          ? (exhibit.fields.image.fields.file.url.startsWith('//') ? 'https:' + exhibit.fields.image.fields.file.url : exhibit.fields.image.fields.file.url)
          : undefined;
        this.seo.updateTags({
          title: title,
          description: description,
          image: imageUrl,
          url: `/exhibits/${this.route.snapshot.paramMap.get('slug')}`,
          type: 'article'
        });
      }
    });
  }

}
